/**
 * Implement Gatsby's Browser APIs in this file.
 */

import React from 'react'
import CookieConsent from './src/components/CookieConsent'

// Import the SPARKEY Design System global styles
import './src/styles/sparkey-design-system.css'

// Cookie consent banner on every page (client-only; SSR renders nothing).
export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <CookieConsent />
  </>
)
